import React from "react";
import { useTranslation } from "react-i18next";
import { IconCircleX, IconDownload } from "@tabler/icons-react";
import { useRole } from "hooks";

const ImportUserFailureDialog = ({ open, isFailureValidation, onClose, onClickDownload }) => {
  const { t: getLabel } = useTranslation();
  const { isServiceAdmin } = useRole();

  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div className="modal modal-blur fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-body d-flex flex-column align-items-center justify-content-center" style={{ padding: "32px 16px" }}>
              <IconCircleX size={64} color="red" style={{ marginBottom: 16 }} />
              <strong style={{ fontSize: "15px", textAlign: "center", color: "red" }}>
                {getLabel(isFailureValidation ? "TXT_FILE_NOT_VALID" : "TXT_IMPORT_FAILURE")}
              </strong>
              <p style={{ fontSize: "15px", textAlign: "center", marginBottom: "16px", whiteSpace: "pre-line" }}>
                {getLabel(
                  isFailureValidation
                    ? isServiceAdmin
                      ? "TXT_INVALID_FILE_COLUMNS_MSG"
                      : "TXT_CHOOSE_ANOTHER_FILE_MSG"
                    : "TXT_IMPORT_FAILURE_MSG"
                )}
              </p>
              {isFailureValidation ? (
                <button className="btn btn-primary" style={{ minWidth: "200px" }} onClick={onClose}>
                  {getLabel("L_ACCEPT")}
                </button>
              ) : (
                <div className="d-flex align-items-center justify-content-center gap-3">
                  <button className="btn btn-outline-danger" style={{ minWidth: "200px" }} onClick={onClose}>
                    {getLabel("L_CANCEL_BUTTON")}
                  </button>
                  <button className="btn btn-primary" style={{ minWidth: "200px" }} onClick={onClickDownload}>
                    <IconDownload size={16} className="me-1" />
                    {getLabel("L_DOWNLOAD_FILE")}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ImportUserFailureDialog;
